var ukUA = {
	"codeBlock.copied": "Скопійовано",
	"codeBlock.copyLabel": "Копіювати",
	"inlineCodeBlock.copied": "Скопійовано",
	"inlineCodeBlock.copyLabel": "Копіювання вбудованого коду"
};

export { ukUA as default };
